export default "__VITE_ASSET__yKml84Eo__"